// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1Dh-N","alertIcon":"ConfirmModal_alertIcon__1LiC8"};